// Maintenance.tsx
import React from "react";
import appConfig from "../../constants/config";

const Maintenance: React.FC = () => {
  return (
    <div style={{ padding: "2%", fontFamily: "verdana", textAlign: "center", lineHeight: "30px", marginTop: "1%" }}>
      <div style={{ width: "100%", height: "100px", position: "relative" }}>
        <h1
          style={{
            color: "#AB1032",
            fontWeight: "bolder",
            fontFamily: "Arial",
            lineHeight: "100px",
          }}
        >
          EEC SITE is currently under maintenance
        </h1>
        <img
          alt="DKSH"
          src={`${appConfig.connectionString.appBaseName}/images/logo_dksh_new.png`}
          style={{
            marginTop: "25px",
            marginRight: "25px",
            height: "50px",
            position: "absolute",
            top: 0,
            right: 0,
          }}
        />
      </div>

      <img src={`${appConfig.connectionString.appBaseName}/images/maintenance.png`} alt="Maintenance" style={{ width: "20%" }} />

      <p style={{ fontSize: "16px", fontWeight: 400, color: "#004080" }}>
        Apology on any inconvenience caused.
        <br />
        Our website is going through a maintenance from{" "}
        <strong>{localStorage.getItem(`maintenanceStartDate`)} till {localStorage.getItem(`maintenanceEndDate`)}</strong>.
      </p>

      <p style={{ fontSize: "16px", color: "#333" }}>
        Thank you and we will be back soon!!!
      </p>
    </div>
  );
};

export default Maintenance;
